var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jmk-home literature-home"},[_c('sbanner'),_c('div',{staticClass:"container"},[(_vm.colums && _vm.colums.length)?_c('sub-cate',{attrs:{"cateList":_vm.colums},on:{"clickChange":_vm.changeCate}}):_vm._e(),_vm._l((_vm.colums),function(item,index){return [_c('Item',{key:index,attrs:{"row":item,"colums":_vm.colums}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }